t<template>
  <!--this component is mostly same with DeviceUnitCreateDialog, will combine later-->
  <v-card>
    <v-toolbar dense elevation="1" v-if="isAllAddMode">
      <v-spacer />
      <v-toolbar-title>
        グループ作成
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="clearAll" v-on="on"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <validate-observer ref="observer">
          <v-row>
            <v-col>
              <validate-provider
                v-slot="{ errors }"
                name="type"
                rules="selectInput"
              >
                <v-combobox
                  v-model="groupDraft"
                  :items="groups"
                  item-text="name"
                  prepend-icon="mdi-folder"
                  label="グループ名を作成 or 選択"
                  multiple
                  chips
                  :error-messages="errors"
                >
                </v-combobox>
              </validate-provider>
            </v-col>
          </v-row>
          <v-row v-if="isAllAddMode">
            <v-col>
              <validate-provider
                v-slot="{ errors }"
                name="type"
                rules="selection"
              >
                <v-select
                  v-model="selectedDevicesUnits"
                  :items="unitDeviceLists"
                  item-text="label"
                  label="登録するユニット or デバイス"
                  prepend-icon="mdi-camera"
                  multiple
                  return-object
                  :error-messages="errors"
                >
                  <template v-slot:item="{ item, attrs }">
                    <v-list-item-action>
                      <v-checkbox :input-value="attrs.inputValue" />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <v-icon class="mr-1" x-small>
                          {{ getTypeIcon(item.type) }}</v-icon
                        >
                        <span class="text-caption grey--text mr-2">{{
                          getTypeName(item.type)
                        }}</span>
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-chip
                      label
                      medium
                      close
                      @click:close="removeSelectItem(item)"
                      :color="item.type === 'unit' ? 'unit' : 'grey'"
                      class="white--text"
                    >
                      <v-icon class="mr-2"> {{ getTypeIcon(item.type) }}</v-icon
                      >{{ item.label }}</v-chip
                    >
                  </template>
                </v-select>
              </validate-provider>
            </v-col>
          </v-row>
        </validate-observer>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="warning" outlined @click="clearAll">
        キャンセル
      </v-btn>
      <v-btn color="success" outlined @click="updateDevice()">
        追加
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidateObserver, ValidateProvider } from '@/plugins/validators'
import { deviceFunctionsMixin } from '@/plugins/mixins'
import { concat, flattenDeep } from 'lodash/core'
import { uniq, uniqBy } from 'lodash/array'
import {
  addDeviceGroup,
  updateDeviceGroup
} from '@/firebaseAccess/firestoreAccess'
const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
  name: 'DeviceUnitEditDialog',
  mixins: [deviceFunctionsMixin],
  props: {
    groups: {
      type: Array,
      required: true
    },
    units: {
      type: Array,
      required: true
    },
    devices: {
      type: Array,
      required: true
    },
    selectedDevice: {
      type: Object,
      required: false
    },
    isAllAddMode: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ValidateProvider,
    ValidateObserver
  },
  data: () => ({
    selectedDevicesUnits: [],
    groupDraft: [],
    deviceDraft: {},
    newUnits: []
  }),
  computed: {
    ...mapGetters({
      userId: 'users/getActiveUserId'
    }),
    unitDeviceLists() {
      const deviceLists = this.getDeviceTypeList(this.devices)
      let unitLists = this.getUnitTypeList(this.units)
      // make group => unit => device model
      unitLists = unitLists.concat(deviceLists)
      return unitLists
    }
  },
  methods: {
    removeSelectItem(item) {
      const index = this.selectedDevicesUnits.indexOf(item)
      this.selectedDevicesUnits.splice(index, 1)
    },
    clearDraftGroup() {
      this.groupDraft = []
      this.selectedDevicesUnits = []
    },
    clearAll() {
      this.$emit('clickClear')
      this.clearDraftGroup()
    },
    async updateDevice() {
      // add validation here
      const groupIds = []
      for (const group of this.groupDraft) {
        if (typeof group !== 'object') {
          await wait(30)
          const groupDraft = {
            owner: this.userId,
            name: group
          }

          const newGroup = await addDeviceGroup(groupDraft, true)
          groupIds.push(newGroup.id)
        } else {
          groupIds.push(group.id)
        }
      }
      // deviceId direct register, UnitId create Ref to GroupDoc
      const deviceDrafts = this.selectedDevicesUnits
        .filter(d => d.type === 'device')
        .map(e => {
          return {
            id: e.id,
            groups: this.devices.find(d => d.id === e.id).groups
          }
        })

      const unitsId = this.selectedDevicesUnits
        .filter(d => d.type === 'unit')
        .map(e => e.id)

      // update group, add group to device directly
      if (unitsId.length) {
        const groupDrafts = groupIds.map(i => {
          return {
            id: i,
            units: this.groups.find(g => g.id === i).units || []
          }
        })
        for (const group of groupDrafts) {
          group.units = uniq(group.units.concat(unitsId)).filter(u => u !== '')
          await updateDeviceGroup(group.id, group, true)
        }
      }

      // update device, add group to device directly
      if (this.isAllAddMode) {
        if (deviceDrafts.length) {
          for (const device of deviceDrafts) {
            device.groups = uniqBy(device.groups.concat(groupIds))
            this.$emit('updateDevice', device)
          }
        }
      } else {
        const device = this.selectedDevice
        device.groups = uniq(device.groups.concat(groupIds))
        this.$emit('updateDevice', device)
      }
      // close dialog
      this.clearAll()
      this.clearDraftGroup()
    },
    getIncludeUnitsDevice(groupDraft) {
      // return group include unit & device type
      // get child units
      const groups = groupDraft.filter(g => g.id !== undefined)
      this.selectedDevicesUnits = concat(
        this.getUnitTypeFromId(
          flattenDeep(
            groups.map(e => this.getUnitsFromGroupId(e.id, this.groups))
          ).filter(f => f !== ''),
          this.units
        ),
        flattenDeep(
          groups.map(g =>
            this.getDeviceTypeList(this.getDevicesInGroup(g, this.devices))
          )
        )
      )
    }
  }
}
</script>
